import { Insights } from './Insights';
import { Reports } from './Reports';

export const InsightsRoute = Insights;

export const InsightsReportsRoute = Reports;
